import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../customComponent/BreadCrumbs";
import { breadcrumbNameMap, ImageBaseUrl } from "../../utils/helperData";
import { Box, Modal, TextField } from "@mui/material";
import { IoIosSearch } from "react-icons/io";
import { RxCrossCircled } from "react-icons/rx";
import SuccessBackground from "../../../asesst/SuccessBackground.svg";
import Tick from "../../../asesst/tick.svg";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";
import { MdEmail } from "react-icons/md";
import { PiPhoneOutgoingFill } from "react-icons/pi";
import { IoMdPerson } from "react-icons/io";
import { HiPlusSmall } from "react-icons/hi2";
import {
  EditProject,
  GetProjectDetails,
} from "../../../redux/action/ProjectManagement/ProjectManagentAction";
import { MANAGE_PROJECT } from "../../utils/RouteConstant";
import { fetchInspectors, uploadEditFiles } from "../../../redux/action/InspectorManagement/AddInspectorAction";
import { CiCircleRemove } from "react-icons/ci";

const EditManageProject = () => {
  const dispatch = useDispatch();
  const { projectId } = useParams();
  const navigate = useNavigate();
  const [pendingInspectors, setPendingInspectors] = useState([]);
  const [assignedInspectors, setAssignedInspectors] = useState([]);
  const [openAddInspectorModal, setOpenAddInspectorModal] = useState(false);
  const [editCofirmationModal, setEditCofirmationModal] = useState(false);
  const [editConfirmationModal, setEditConfirmationModal] = useState(false);
  const [saveDetailsModal, setSaveDetailsModal] = useState(false);
  const [deleteConfirmationModal, setDeleteConfirmationModal] = useState(false);
  const [inspectorToDelete, setInspectorToDelete] = useState(null);

  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState("");
  console.log("preview image", preview)
  const [fileName, setFileName] = useState("");
  const [errors, setErrors] = useState({});
  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [
      "client_name",
      "client_id",
      "project_no",
      "name",
      "description",
    ];

    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = `${field.replace("_", " ")} is required.`;
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const itemsPerPage = 1000;
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [formData, setFormData] = useState({
    client_name: "",
    client_id: "",
    project_no: "",
    name: "",
    description: "",
    project_id: projectId || "",
  });

  const { projectDetails } = useSelector((state) => state.project);

  const { inspectorData } = useSelector((state) => state.inspector);
  useEffect(() => {
    if (projectId) {
      dispatch(GetProjectDetails(projectId));
    }
  }, [projectId]);

  const [openSaveModal, setOpenSaveModal] = useState(false);
  const handleCloseSaveModal = () => {
    setOpenSaveModal(false);
    navigate(MANAGE_PROJECT);
  };
  useEffect(() => {
    dispatch(fetchInspectors(currentPage, searchTerm, itemsPerPage));
  }, [dispatch, currentPage, searchTerm]);

  useEffect(() => {
    if (projectDetails) {
      setFormData({
        ...formData,
        client_name: projectDetails?.client_name || "",
        client_id: projectDetails?.client_id || "",
        project_no: projectDetails?.project_id || "",
        name: projectDetails?.name || "",
        description: projectDetails?.description || "",
        project_id: projectDetails?._id || "",
      });
      if (projectDetails?.document) {
        setPreview(projectDetails?.document);
      }
      setAssignedInspectors(projectDetails?.inspector_id || []);
    }
  }, [projectDetails]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      showPreview(selectedFile);
      setFileName(selectedFile.name);
    }
  };


  // Handle drag and drop
  const handleDragOver = (event) => {
    event.preventDefault();
    event.currentTarget.classList.add("active");
  };

   const handleDragLeave = (event) => {
     event.currentTarget.classList.remove("active");
   };

  const handleDrop = (event) => {
    event.preventDefault();
    const droppedFile = event.dataTransfer.files[0];
    if (droppedFile) {
      showPreview(droppedFile);
      setFileName(droppedFile.name);
    }
    event.currentTarget.classList.remove("active");
  };

  // Show preview of the uploaded file
   const showPreview = (file) => {
     if (file.type.startsWith("image/")) {
       const reader = new FileReader();
       reader.onload = () => {
         setPreview(reader.result);
         setFile(file);
       };
       reader.readAsDataURL(file);
     }
   };

  // Handle file deletion
  const handleDelete = () => {
    setFile(null);
    setPreview("");
    setFileName("");
  };

  const handleOpenAddInspectorModal = () => {
    setPendingInspectors([]);
    setOpenAddInspectorModal(true);
  };

  const handleCloseAddInspectporModal = () => {
    setOpenAddInspectorModal(false);
    setSearchTerm("");
    setPendingInspectors([]);
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleEditCofirmationModal = () => {
    setEditCofirmationModal(true);
  };

  const handleCloseConfirmationModal = () => {
    setEditCofirmationModal(false);
  };

  const handleConfirmEdit = () => {
    setEditConfirmationModal(false);
    setSaveDetailsModal(true);
    setOpenSaveModal(true);
    handleCloseConfirmationModal();
  };

  const handleRemoveInspector = (e, inspectorId) => {
    e.stopPropagation();
    e.preventDefault();
    setInspectorToDelete(inspectorId);
    setDeleteConfirmationModal(true);
  };

  const confirmDeleteInspector = () => {
    setAssignedInspectors((prev) =>
      prev.filter((id) => id !== inspectorToDelete)
    );
    setDeleteConfirmationModal(false);
    setInspectorToDelete(null);
  };

  const cancelDeleteInspector = () => {
    setDeleteConfirmationModal(false);
    setInspectorToDelete(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }

    try {
       let filePath = projectDetails?.document; 
     if (file) {
       const uploadResponse = await dispatch(uploadEditFiles([file]));
       if (!uploadResponse.success) {
         console.error("File upload failed:", uploadResponse.error);
         return;
       }
       filePath = uploadResponse?.data?.data[0]?.filePath;
     }

      // Prepare data for editing the project
       const projectData = {
         ...formData,
         inspector_id: assignedInspectors,
         document: filePath,
       };

      await dispatch(EditProject(projectData));
      handleEditCofirmationModal();
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const truncateString = (str) => {
    if (str?.length > 12) {
      return str.slice(0, 10) + "...";
    }
    return str;
  };

  const handleAssignInspector = () => {
    setAssignedInspectors((prev) => [...prev, ...pendingInspectors]);
    handleCloseAddInspectporModal();
  };

  const handleCancelProject = () => {
    setFormData("");
    navigate(MANAGE_PROJECT);
    setAssignedInspectors([]);
  };

  // const toggleInspectorSelection = (id) => {
  //   setPendingInspectors((prevSelected) => {
  //     if (prevSelected.includes(id)) {
  //       return prevSelected.filter((inspectorId) => inspectorId !== id);
  //     } else {
  //       return [...prevSelected, id];
  //     }
  //   });
  // };

   const toggleInspectorSelection = (id) => {
     setPendingInspectors((prevSelected) => {
       const isAssigned = assignedInspectors.includes(id);

       if (prevSelected.includes(id)) {
         return prevSelected.filter((inspectorId) => inspectorId !== id);
       } else if (isAssigned) {
         setAssignedInspectors((prev) =>
           prev.filter((inspectorId) => inspectorId !== id)
         );
         return prevSelected;
       } else {
         return [...prevSelected, id];
       }
     });
   };
   const isInspectorSelected = (inspectorId) => {
     return (
       pendingInspectors.includes(inspectorId) ||
       assignedInspectors.includes(inspectorId)
     );
   };

  const projectInspectors = inspectorData?.data?.filter((inspector) =>
    assignedInspectors.includes(inspector._id)
  );

  return (
    <div>
      <div className=" mb-6">
        <h2 className="text-3xl font-bold mb-6">Project Management</h2>
        <Breadcrumbs breadcrumbNameMap={breadcrumbNameMap} />
      </div>
      <div className="mx-auto bg-white shadow-lg rounded-lg p-8">
        <div>
          <h2 className="text-2xl font-base font-poppins mb-8 text-[#202224]">
            Edit Project
          </h2>
        </div>
        <form onSubmit={handleSubmit}>
          <div>
            <h3 className="text-base font-base text-[#1C3664] mb-2">
              Project Details
            </h3>
            <div
              style={{ borderBottom: "3px solid #1C3664", width: "5%" }}
            ></div>
            <div className="space-y-4 md:space-y-6 pt-6">
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                <TextField
                  label="Client Name *"
                  name="client_name"
                  value={formData?.client_name}
                  onChange={handleChange}
                  required={false}
                  error={!!errors.client_name}
                  helperText={errors.client_name}
                />
                <TextField
                  label="Client ID *"
                  name="client_id"
                  value={formData?.client_id}
                  onChange={handleChange}
                  required={false}
                  error={!!errors.client_id}
                  helperText={errors.client_id}
                />
                <TextField
                  label="Project ID *"
                  name="project_no"
                  value={formData?.project_no}
                  onChange={handleChange}
                  required={false}
                  error={!!errors.project_no}
                  helperText={errors.project_no}
                />
                <TextField
                  label="Project Name *"
                  name="name"
                  value={formData?.name}
                  onChange={handleChange}
                  required={false}
                  error={!!errors.name}
                  helperText={errors.name}
                />
                <div className="upload-container relative flex items-center justify-between w-full">
                  <div
                    className="drop-area w-full rounded-md border border-solid border-slate-300 transition-all hover:border-black text-center"
                    onDragOver={handleDragOver}
                    onDragLeave={handleDragLeave}
                    onDrop={handleDrop}
                  >
                    <label
                      htmlFor="file-input"
                      className="block w-full h-full text-gray-500 p-4 text-base cursor-pointer"
                    >
                      {!preview ? (
                        "Upload image or click to browse"
                      ) : (
                        <div className="preview-container flex justify-between items-center gap-4">
                          <img
                            src={
                              preview.startsWith("data:")
                                ? preview
                                : `${ImageBaseUrl}${preview}`
                            }
                            alt="Preview"
                            className="preview-image w-40 h-24 bg-cover bg-center rounded-md"
                          />
                          {/* <span className="file-name text-sm font-medium">
                            {projectDetails?.document?.length > 15
                              ? `${projectDetails?.document.substring( 0, 15)}...`
                              : projectDetails?.document}
                          </span> */}
                          <RxCrossCircled
                            onClick={(e) => {
                              e.preventDefault();
                              handleDelete();
                            }}
                            className="h-8 w-8 cursor-pointer"
                          />
                        </div>
                      )}
                    </label>
                    <input
                      name="file"
                      type="file"
                      id="file-input"
                      accept="image/*"
                      className="hidden"
                      onChange={handleFileChange}
                    />
                  </div>
                </div>
              </div>
            </div>

            <TextField
              label="Project Description *"
              name="description"
              multiline
              minRows={6}
              maxRows={6}
              sx={{
                resize: "none",
                marginTop: "40px",
                width: "100%",
              }}
              variant="outlined"
              value={formData?.description}
              onChange={handleChange}
              required={false}
              error={!!errors.description}
              helperText={errors.description}
            />
          </div>

          {assignedInspectors.length === 0 ? (
            <div>
              <h3 className="text-base font-base text-[#1C3664] mt-6 mb-2">
                Assigned User Details
              </h3>
              <div
                style={{ borderBottom: "3px solid #1C3664", width: "5%" }}
              ></div>

              <div
                onClick={handleOpenAddInspectorModal}
                className="relative w-full sm:w-64 mt-8 flex-grow sm:flex-grow-0"
              >
                <input
                  type="text"
                  placeholder="Search inspector by name and email"
                  className="w-full lg:w-[400px] pl-10 pr-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
                <IoIosSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
              </div>
            </div>
          ) : (
            <div className="mt-6">
              <div className="flex flex-col sm:flex-row justify-between items-center mb-6 space-y-4 sm:space-y-0 sm:space-x-4">
                <div className="  ">
                  <h3 className="text-base font-base text-[#1C3664] mt-6 mb-2">
                    Assigned User Details
                  </h3>
                  <div
                    style={{ borderBottom: "3px solid #1C3664", width: "50%" }}
                  ></div>
                </div>
                <div
                  style={{ border: "1px solid #1C3664", borderRadius: "8px" }}
                >
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      handleOpenAddInspectorModal();
                    }}
                    className="w-full sm:w-auto text-[#1C3664] px-4 py-2 rounded-lg flex items-center justify-center"
                  >
                    <HiPlusSmall className="mr-2 text-lg" />
                    Add New
                  </button>
                </div>
              </div>
              <div className="mt-12">
                <table className="min-w-full bg-white border border-gray-300">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="py-2 px-4 border-b text-left">
                        Employee ID
                      </th>
                      <th className="py-2 px-4 border-b text-left">
                        User Name
                      </th>
                      <th className="py-2 px-4 border-b text-left">
                        Mobile Number
                      </th>
                      <th className="py-2 px-4 border-b text-left">Email</th>

                      <th className="py-2 px-4 border-b text-left">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {projectInspectors &&
                      projectInspectors.map((inspector) => (
                        <tr key={inspector._id} className="hover:bg-gray-50">
                          <td
                            className="py-2 px-4 border-b text-left text-slate-500"
                            disabled
                          >
                            {inspector.id}
                          </td>
                          <td
                            className="py-2 px-4 border-b text-left text-slate-500"
                            disabled
                          >
                            {inspector.inspector_name}
                          </td>
                          <td
                            className="py-2 px-4 border-b text-left text-slate-500"
                            disabled
                          >
                            {inspector.mobile_number}
                          </td>
                          <td
                            className="py-2 px-4 border-b text-left text-slate-500"
                            disabled
                          >
                            {inspector.email}
                          </td>

                          <td className="py-2 px-4 border-b text-left">
                            <button>
                              <CiCircleRemove
                                size={24}
                                onClick={(e) =>
                                  handleRemoveInspector(e, inspector._id)
                                }
                              />
                            </button>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {errors.inspectors && (
            <p className="text-red-500 mt-2">{errors.inspectors}</p>
          )}
          <div className="flex justify-end space-x-4 mt-4 ">
            <button
              onClick={handleCancelProject}
              className="px-4 py-2 bg-gray-300 text-gray-700 rounded-md"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-[#1C3664] text-white rounded-md"
            >
              Save Details
            </button>
          </div>

          <Modal
            open={editCofirmationModal}
            className="justiify-center items-center flex"
          >
            <Box className="bg-white text-center p-4 rounded-2xl shadow-md w-[23%] mx-auto">
              <div className="text-center">
                <p className="font-normal text-lg mt-2 text-[#6D6D6D]">
                  Are you sure you want to edit?
                </p>
              </div>
              <div className="flex justify-center space-x-6 my-6">
                <button
                  type="submit"
                  onClick={handleConfirmEdit}
                  className="bg-[#FFFFFF] border w-[70px] px-4 py-2 rounded-lg"
                >
                  Yes
                </button>
                <button
                  onClick={handleCloseConfirmationModal}
                  className="bg-[#1C3664] border w-[70px] text-white px-4 py-2 rounded-lg"
                >
                  No
                </button>
              </div>
            </Box>
          </Modal>
        </form>
        <br />
      </div>

      <Modal
        open={deleteConfirmationModal}
        onClose={cancelDeleteInspector}
        className="flex items-center justify-center"
      >
        <Box className="bg-white text-center p-4 rounded-2xl shadow-md w-[90%] max-w-md mx-auto">
          <h2 className="text-xl font-bold mb-4">Confirm Deletion</h2>
          <p className="mb-6">
            Are you sure you want to remove this inspector?
          </p>
          <div className="flex justify-center space-x-4">
            <button
              onClick={confirmDeleteInspector}
              className="bg-red-500 text-white px-4 py-2 rounded-lg"
            >
              Yes, Remove
            </button>
            <button
              onClick={cancelDeleteInspector}
              className="bg-gray-300 text-gray-700 px-4 py-2 rounded-lg"
            >
              Cancel
            </button>
          </div>
        </Box>
      </Modal>

      {openAddInspectorModal && (
        <Modal
          open={openAddInspectorModal}
          className="justiify-center items-center flex"
        >
          <Box className="bg-white text-center p-10 rounded-2xl shadow-md max-w-full mx-auto">
            <div>
              <div className="flex justify-between">
                <div>
                  <h2 className="text-2xl text-[#1C3664] font-semibold">
                    Assign Inspector / User
                  </h2>
                </div>
                <div>
                  <RxCrossCircled
                    onClick={handleCloseAddInspectporModal}
                    className=" top-2 h-6 w-6 cursor-pointer"
                  />
                </div>
              </div>
              <div className="relative w-full mt-6 mb-6">
                <input
                  type="text"
                  value={searchTerm}
                  onChange={handleSearch}
                  placeholder="Search inspector by name and email"
                  className="w-full lg:w-[100%] pl-10 pr-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
                <IoIosSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
              </div>
              <div className="max-h-64 overflow-y-auto">
                {inspectorData &&
                  inspectorData?.data?.map((inspector, index) => (
                    <div
                      key={inspector._id}
                      className="flex items-start py-3 border-b last:border-b-0"
                    >
                      <input
                        type="checkbox"
                        // checked={assignedInspectors.includes(inspector._id)}
                        // checked={pendingInspectors.includes(inspector?._id)}
                        checked={isInspectorSelected(inspector?._id)}
                        // checked={pendingInspectors.includes(inspector._id)}
                        onChange={() => toggleInspectorSelection(inspector._id)}
                        className="mt-[6px] mr-4 form-checkbox h-4 w-4 text-blue-600 rounded border-gray-300"
                      />
                      <div className="flex gap-8">
                        <div className="flex items-center text-[#1C3664] text-sm mt-1">
                          <IoMdPerson className="mr-2 text-sm" />
                          <span>
                            {truncateString(inspector?.inspector_name)}
                          </span>
                        </div>
                        <div className="flex items-center text-[#626262] text-sm mt-1">
                          <PiPhoneOutgoingFill className="mr-2" />
                          <span>{truncateString(inspector.mobile_number)}</span>
                        </div>
                        <div className="flex items-center text-[#626262] text-sm mt-1">
                          <MdEmail className="mr-2" />
                          <span>{truncateString(inspector.email)}</span>
                        </div>
                      </div>
                    </div>
                  ))}

                {inspectorData?.data?.length === 0 && (
                  <tr>
                    <td colSpan="12" className="px-6 text-center text-gray-500">
                      <div className="flex flex-col items-center justify-center">
                        <img
                          src="https://img.freepik.com/premium-vector/no-data-concept-illustration_86047-488.jpg?semt=ais_hybrid"
                          alt="No Data"
                          className=" w-[370px] h-[200px]"
                        />
                        <p className="text-lg text-gray-500">
                          No results found
                        </p>
                        <p className="text-sm text-gray-400">
                          Please check back later or create Inspection.
                        </p>
                      </div>
                    </td>
                  </tr>
                )}
              </div>

              <div className="flex justify-end space-x-4 mt-6">
                <button
                  onClick={handleCloseAddInspectporModal}
                  className="px-4 py-2 bg-gray-300 text-gray-700 rounded-md"
                >
                  Cancel
                </button>
                <button
                  onClick={handleAssignInspector}
                  className="px-4 py-2 bg-[#1C3664] text-white rounded-md"
                >
                  Assign Inspector
                </button>
              </div>
            </div>
          </Box>
        </Modal>
      )}

      {openSaveModal && (
        <Modal open={openSaveModal} className="justify-center items-center ">
          <Box className="bg-white text-center p-6 rounded-2xl shadow-md max-w-lg mx-auto my-20">
            <RxCrossCircled
              onClick={handleCloseSaveModal}
              className="float-end top-2 h-6 w-6 cursor-pointer"
            />
            <div className="text-center inline-flex mt-8">
              <div
                className="w-[72px] h-[72px] flex items-center justify-center"
                style={{ backgroundImage: `url(${SuccessBackground}` }}
              >
                <img src={Tick} alt="Success" className="w-7 h-7" />
              </div>
            </div>
            <p className="text-3xl text-[#0B0B0B] font-semibold mt-4 mb-4">
              Success
            </p>
            <span className="text-[#6D6D6D]">Project Update successfully</span>
            <div className="mt-6 flex justify-center gap-4">
              <button
                onClick={handleCloseSaveModal}
                className="border border-inherit px-4 py-2 rounded-lg"
              >
                Close
              </button>
            </div>
          </Box>
        </Modal>
      )}
    </div>
  );
};
export default EditManageProject;
